import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from "class-validator";
import { AdapterCalendarDay } from "../adapter-calendar-day.dto";
import { AdapterCalendarShift } from "../adapter-calendar-shift.dto";

@ValidatorConstraint({ async: true })
class IsCalendarShiftRequiredConstraint
  implements ValidatorConstraintInterface
{
  // TODO: review and adjust as necessary
  validate(value: any, args: ValidationArguments): Promise<boolean> | boolean {
    const dto: AdapterCalendarShift = args.object as AdapterCalendarShift;
    const { shift, shift_id, available_hours } = dto;
    return Number(available_hours) > 0 ? !!shift && !!shift_id : true;

    /*const { shifts } = dto;
    let result = false;
    for (let shiftDetails of shifts || []) {
      const { shift, shift_id, available_hours } = shiftDetails;
      result = Number(available_hours) > 0 ? !!shift && !!shift_id : true;
      if (result) {
        break;
      }
    }
    return result;*/
  }
}

export function IsCalendarShiftRequired(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      constraints: [validationOptions?.context],
      validator: IsCalendarShiftRequiredConstraint,
    });
  };
}
